// [ISO code, name, dial code, display currency]
export const COUNTRIES = [
  ["IN", "India", "+91", "INR"], ["US", "United States", "+1", "USD"], ["GB", "United Kingdom", "+44", "GBP"],
  ["AE", "United Arab Emirates", "+971", "AED"], ["SG", "Singapore", "+65", "SGD"], ["AU", "Australia", "+61", "AUD"],
  ["CA", "Canada", "+1", "CAD"], ["DE", "Germany", "+49", "EUR"], ["FR", "France", "+33", "EUR"],
  ["IT", "Italy", "+39", "EUR"], ["ES", "Spain", "+34", "EUR"], ["NL", "Netherlands", "+31", "EUR"],
  ["IE", "Ireland", "+353", "EUR"], ["BE", "Belgium", "+32", "EUR"], ["AT", "Austria", "+43", "EUR"],
  ["PT", "Portugal", "+351", "EUR"], ["FI", "Finland", "+358", "EUR"], ["GR", "Greece", "+30", "EUR"],
  ["SA", "Saudi Arabia", "+966", "USD"], ["QA", "Qatar", "+974", "USD"], ["KW", "Kuwait", "+965", "USD"],
  ["OM", "Oman", "+968", "USD"], ["BH", "Bahrain", "+973", "USD"], ["NZ", "New Zealand", "+64", "AUD"],
  ["MY", "Malaysia", "+60", "SGD"], ["HK", "Hong Kong", "+852", "USD"], ["JP", "Japan", "+81", "USD"],
  ["CH", "Switzerland", "+41", "EUR"], ["SE", "Sweden", "+46", "EUR"], ["NO", "Norway", "+47", "EUR"],
  ["DK", "Denmark", "+45", "EUR"], ["ZA", "South Africa", "+27", "USD"], ["NP", "Nepal", "+977", "INR"],
  ["LK", "Sri Lanka", "+94", "USD"], ["BD", "Bangladesh", "+880", "USD"], ["TH", "Thailand", "+66", "USD"],
  ["ID", "Indonesia", "+62", "USD"], ["PH", "Philippines", "+63", "USD"], ["KE", "Kenya", "+254", "USD"],
  ["NG", "Nigeria", "+234", "USD"], ["MU", "Mauritius", "+230", "USD"], ["BR", "Brazil", "+55", "USD"],
  ["MX", "Mexico", "+52", "USD"],
];

export const countryByCode = (c) => COUNTRIES.find(x => x[0] === c) || COUNTRIES[0];
